import React from "react";
import { Header } from "semantic-ui-react";

import "./style.css";

const SingleBlog = () => {
    return (
        <>
            <Header as="h1" id="blog-header">Single Blog</Header>
        </>
    );
};

export default SingleBlog;